export default __webpack_public_path__ + "static/media/oleh.751c1b3c.png";